import { render, staticRenderFns } from "./TemplatesSingle.vue?vue&type=template&id=34b69d79&"
import script from "./TemplatesSingle.vue?vue&type=script&lang=js&"
export * from "./TemplatesSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports